import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import ReportsProvider from 'state/providers/ReportsProvider';
import ReportSectionHeader from './components/common/ReportSectionHeader';
import ReportContainer from './components/common/ReportContainer';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import useTeachingOrderStore from 'graph/state/query-hooks/use-teaching-order';
import useClassrooms from 'state/hooks/use-classrooms';
import { PrintContext } from './components/common/ReportDownloadButton';

const Reporting: React.FC = () => {
  const [{ isLoading, error }] = useTeachingOrderStore();
  const [{ activeClassroom }] = useClassrooms();
  const reportRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: `Student Progress_${activeClassroom.name}_${new Date().getTime()}`,
  });

  return (
    <ReportsProvider>
      <PrintContext.Provider value={{ handlePrint }}>
        <ReportSectionHeader />
        <div ref={reportRef}>
          <WithQuery loading={isLoading} error={error}>
            <ReportContainer />
          </WithQuery>
        </div>
      </PrintContext.Provider>
    </ReportsProvider>
  );
};

export default Reporting;
